import * as React from "react";
import usoInstalacionesImg from "../../res/images/uso_instalaciones.png";
import deportistasImg from "../../res/images/cartel_deportistas.png";
import {ROUTE_COVID_RULES} from "../../routing/Routes";
import {useLocation} from "react-router";

const CovidContent = () => {

    const location = useLocation();
    const imgClass = location.pathname === ROUTE_COVID_RULES ?
        "content-image page-blank" : "content-image";

    return (
        <>
            <div className={imgClass}>
                <img src={usoInstalacionesImg} alt={'Normas Covid'}/>
            </div>
            <div className={imgClass}>
                <img src={deportistasImg} alt={"Uso instalaciones Covid"}/>
            </div>
        </>
    )
}

export default CovidContent;